import { createFetch } from '@vueuse/core'
import { useAuthStore } from '@/modules/auth/stores/auth-store'
import { useNotificationStore } from '@/modules/shared/stores/notification-store'

export const useFetch = createFetch({
  baseUrl: import.meta.env.VITE_VENTURE360_API_URL,
  options: {
    async beforeFetch({ options }) {
      const authStore = useAuthStore()

      if (authStore.access_token) {
        options.headers['Authorization'] = `Bearer ${authStore.access_token}`
      }

      options.credentials = 'include'

      return { options }
    },

    updateDataOnError: true, // enables access to the error object in the returned data

    // Surface 403s (read-only "view as" sessions, permission denials) as a toast
    // the same way the custom useFetch composables do.
    onFetchError(ctx) {
      if (ctx.response.status !== 403) return

      const body = ctx.data && typeof ctx.data === 'object' ? (ctx.data as Record<string, unknown>) : {}
      const error = body.error
      const isReadOnly = Array.isArray(error) ? error.includes('read_only') : error === 'read_only'

      useNotificationStore().enqueue(
        'error',
        isReadOnly
          ? 'Changes are not allowed while viewing as another user. Log in as the user to make changes.'
          : (body.message as string) || 'You do not have permission to do that.',
      )

      return ctx
    },
  },
})
